import NotFound from '@/components/error-pages/NotFound';
import { CustomRedirect } from '@/components/navigation';
import React from 'react';
import { useIsBuyer } from '@/utils/hooks';

const ExternalLinkMeetings: React.FC<{ projectId: number }> = ({ projectId }) => {
    const isBuyer = useIsBuyer();

    if (isBuyer) {
        return <CustomRedirect to={`/book-meeting`} />;
    }

    if (!projectId) {
        return <NotFound />;
    }

    return <CustomRedirect to={`/projects/${projectId}/meetings`} />;
};

export default ExternalLinkMeetings;
